// ButtonGenerationUtility.js
// Gemini-only: service references use GeminiService/MobileGeminiService

const ButtonGenerationUtility = {
  generateButtons: async (response) => {
    if (!response || !response.sections || !Array.isArray(response.sections)) {
      console.log('ButtonGenerationUtility - Invalid response:', response);
      return [];
    }

    console.log('ButtonGenerationUtility - Processing response:', response);

    const createButtonWithSpinner = (label, action, section, content) => ({
      label,
      section,
      content,
      action: async (setLoading) => {
        try {
          setLoading(true);
          return { [section]: content };
        } finally {
          setLoading(false);
        }
      },
    });

    const buttons = response.sections.map(section => {
      let sectionKey = (section.name || '').toLowerCase();
      if (sectionKey === 'summary') sectionKey = 'summary';
      else if (sectionKey === 'experience') sectionKey = 'experience';
      else if (sectionKey === 'skills') sectionKey = 'skills';
      else if (sectionKey === 'education') sectionKey = 'education';
      else if (sectionKey === 'publications') sectionKey = 'publications';
      else sectionKey = 'summary'; // fallback
      
      return createButtonWithSpinner(section.button.label, section.button.action, sectionKey, section.content);
    });

    console.log('ButtonGenerationUtility - Generated buttons:', buttons);
    return buttons;
  },
};

export default ButtonGenerationUtility;
